import action from 'utils/action';

// MODALS
export function appModalOpen(payload) {
  return action('APP_MODAL_OPEN', payload);
}

export function appModalClose(payload) {
  return action('APP_MODAL_CLOSE', payload);
}



// WEBPACK FOOTER //
// ./js/actions/app.js